import { createFeatureSelector, createSelector } from '@ngrx/store';
import { sharedLinksFeatureKey, SharedLinkState } from '@pages/share/reducers/shared-link.reducer';

export const selectSharedLinkState = createFeatureSelector<SharedLinkState>(sharedLinksFeatureKey);

export const selectIsHandlingSharedLink = createSelector(
  selectSharedLinkState,
  state => !!(state?.processingSharedLink)
);
